var global_helpers = {

    defaults: {
        breakpoint_desktop: 960,
        slide_spacing: 16,
    },

    settings: {
        anchor_links: $('a[href^="#"]'),
        btn_arrows: $('.js-btn-has-arrow'),
        data_element_links: $('[data-element-link]'),
        header: $('.header-main'),
    },

    init: function () {
        // Button Arrows
        if (this.settings.btn_arrows.length) {
            this.buttonArrows();
        }
        // Data Element Links
        if (this.settings.data_element_links.length) {
            this.dataElementLinks();
        }
        this.bindUIActions();
    },

    bindUIActions: function () {
        // Standard Anchor Links
        global_helpers.settings.anchor_links.on('click', global_helpers.anchorLinks);
    },

    // Smooth scroll to anchor linked items
    anchorLinks: function () {
        var link = $(this).attr('href');
        if (link.length) {
            var target = $(link).first();
            if (target.length) {
                var header = global_helpers.settings.header.outerHeight();
                var offset = target.offset().top - header;
                $('html, body').animate({
                    scrollTop: offset
                }, 1000);
                return false;
            }
        }
    },

    // Button Arrows
    buttonArrows: function() {
        global_helpers.settings.btn_arrows.each(function() {
            $(this).append('<span class="btn-icon--arrow"><svg viewBox="0 0 21.27 8.68" xmlns="http://www.w3.org/2000/svg"><path d="m21.27 4.34-1.05-1.06-.01.01-3.32-3.29-1.06 1.07 2.56 2.52h-18.39v1.5h18.39l-2.56 2.53 1.06 1.06 3.32-3.28h.01l1.05-1.05z"/></svg></span>');
        });
    },

    // Allow links for an entire element that might need to contain another link inside of its content
    dataElementLinks: function() {
        // Needs: data-card-link, data-card-target
        global_helpers.settings.data_element_links.on('click', function(e) {
            if (e.target.nodeName != 'A') {
                var link = $(this).data('element-link');
                var target = $(this).data('element-link-target');
                if (target.length) {
                    window.open(link, target);
                } else {
                    window.location.href = link;
                }
            }
        });
    },

    // Returns a function that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If 'immediate' is passed, trigger the function on the
    // leading edge, instead of the trailing.
    //
    // Use:  $(window).resize(global_helpers.debounce(function() { ...[your code here]... }, 500));
    // Source:  http://davidwalsh.name/javascript-debounce-function
    debounce: function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) { func.apply(context, args); }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) { func.apply(context, args); }
        };
    },

}
global_helpers.init();